import "pixi-spine";

import * as PIXI from 'pixi.js';
import { CreateElement, CreateSpineResources, Log, LogGroup, Point, Rect, Safe, Scale, SetNullReference, Size } from "../../MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage } from "../../ResourceManager/ResourceManager";
import { FillingPotParams } from "./FillinPotParams";
import { IFillingPotIncrements } from "./IFillingPotIncrement";
//import { ZIndex } from "../../ZIndex";
//import { IBone, IBoneData, ISlot, ITrackEntry, Spine, TransformMode } from "pixi-spine";
//import * as pixispine from "pixi-spine";
import { IBone, ISkeletonData, Spine } from "pixi-spine";
//import { EventData } from '@pixi-spine/runtime-4.1';
import { FrontendErrorCode, MultiBonusType, SlotGameBet } from "../../api";
import { AudioManager, Track } from "../../AudioManager";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { RobotPlay } from "../../RobotPlay";
import { service } from "../../services";
import { JackpotDisplayType, Settings } from "../../Settings";
import { FillingPotFamilyFeatureFactory, IFillinPotFamilyFactory } from "./FamilyFactory";
import { IGenericFamilySpine } from "./IGenericFamilySpine";
import { IIncrementSavePerBet, ILevelsPerBetsSaved } from "./ILevelsPerBetSaved";
import { RandomAnimationFeature } from "./RandomAnimationFeature";
import { ClientState } from "../../ClientState";
import { SpinnableReelsBigCanvas } from "../SpinAnimation/SpinnableReelsBigCanvas";
import { PotCollectPosition } from "./CollectSRAPathFillingPot";


// export interface IBoundingBox extends IAttachment {
//     vertices: number[],
// }

// export interface ILevelsPerBetsSaved {
//     currentLevel: number,
//     TotalBet: number,
//     currentSpin: number,
//     particlesCount? : number,
//     particleSaveData: IParticlesSaveData[]
// }

// export interface AnimationListener extends ITrackEntry{
// Animation : IAnimation[]
// }

export interface PlaceHolderMutiPotConfig {
    width: number,
    height: number,
    scaleX: number,
    scaleY:number,
    offsetY : number,
    offsetX : number,
    loopWin : boolean,
}

export class FillingPotGeneric {
    //protected view: HTMLElement = null;
    //protected params: FillingPotParams = null;
    protected logGroup: LogGroup = null;
    protected resid: ResourceIdentifier = null;
    protected app: PIXI.Application<HTMLCanvasElement> = null;
    //protected restoreWebGlInterval: IInterval = null;
    //protected denomsMap: Map<number, number> = new Map<number, number>();
    //protected availableDenoms: number[] = [];
    //protected availableLevelPerBet: ILevelsPerBetsSaved[] = [];
    protected gameResourcesBasePath: string = null;
    protected gameName: string = null;
    //protected changeRandomAnimationSpineInterval: IRandomTimeout = null;
    //protected matterjs: FillingPotPhysical = null;
    //protected containerSpinnableReelsSpine: PIXI.Container = null;
    protected positionSpinnableReelsSpinePivotContainer: Size = null;
    protected viewPixiCanvasSize = new Size(Scale.W(1920), Scale.H(1080));
    protected audio: AudioManager = null;


    protected recoverCount: number = 0;
    protected recoverFailCount: number = 0;
    protected readonly maxRecoverFailCount = 5;

    //protected intervalLevelRAAnimation: IInterval = null;
    //protected restartStartIncrementLevelsOneTime: ITimeout = null;
    //protected startRALevelLoop : ITimeout = null;
    // currentLevel = 0;
    protected params: FillingPotParams;
    protected containerSpinnableReelsSpine: PIXI.Container<PIXI.DisplayObject>;
    protected skinAttachment : number  = 0;
    protected ScreenNumberConfiguration: number = Settings.Screens;
    readonly windowRectangle: Rect = null;
    protected randomAnimationFeature : RandomAnimationFeature = null;
    constructor(params: FillingPotParams) {
        //super(params);
        this.windowRectangle = params.windowRectangle;
        this.params = params;
        this.logGroup = params.logGroup.Add("FillingPotFeature");
        this.resid = params.resid.Add("FillingPotFeature");
        this.skinAttachment = params.skinAttachment;
        if (Settings.Enable2plus1)
        {
            this.ScreenNumberConfiguration = 2;
        }
        // this.view = CreateElement("div", {
        //     classes: [this.resid.Scope()],
        //     style: {
        //         width: this.viewPixiCanvasSize.Width + "px",
        //         height: this.viewPixiCanvasSize.Height * this.ScreenNumberConfiguration + "px",
        //         position: "absolute",
        //         display: "flex",
        //         //zIndex: ZIndex.fillingPotBaseGame + "",
        //         top: (this.viewPixiCanvasSize.Height * (this.ScreenNumberConfiguration - 1)) * -1 + "px",
        //         //background : "rgba(0.5,10,50,0.5)",
        //     }
        // });

        // this.restoreWebGlInterval = params.systemContext.TimingContext().CreateInterval("restoreWebGlIntervalFillingPot", 500, () => {
        //     let success = this.tryRecoverWebglContext();

        //     // success, stop timer
        //     if (!success) {
        //         this.recoverFailCount++;
        //         if (this.recoverFailCount == this.maxRecoverFailCount) {
        //                void service.api.frontendError(FrontendErrorCode.WebGLRecoverFail, `${this.resid.ID()} in ${this.recoverFailCount} tries`);
        //         }
        //     }
        //     success = null;
        // });


        this.gameName = params.gameName;
        this.gameResourcesBasePath = params.gameResourcesBasePath;
        this.audio = params.audio;
        this.spineInitSize = new Size(Scale.W(1920), Scale.H(1080 * this.ScreenNumberConfiguration));
        //globalThis.__PIXI_APP__ = this.app;
        this.randomAnimationFeature = new RandomAnimationFeature(params.gameName , params.audio , params.resid , params.gameResourcesBasePath , params.systemContext);
    }

    protected created: boolean = false;
    /** use for create App Pixi.js*/
    public Create(app?: PIXI.Application<HTMLCanvasElement>) {
        this.created = true;
        if (app == null) {
            Log.Error(this.logGroup, `Create() FillingPot: app not null, don't recreate`);
            throw "missing send the engine";
        }
        this.app = app;
        //try
        {
            this.InternalCreate();
        }
    }

    /** use for create pixi and registred for dont create multi times */
    public InternalCreate() {

        Log.Debug(this.logGroup, `InternalCreate()`);
        if (!this.created) {
            Log.Error(this.logGroup, `InternalCreate() This pixi app is not visible at the moment, so we are not creating it`);
            return;
        }

        


        // Log.Debug(this.logGroup, `Create(): creating reels`);
        /*
        Log.Debug(this.logGroup, `InternalCreate() Creating pixi application`);
        this.app = new PIXI.Application({
            width: this.viewPixiCanvasSize.width,
            height: this.viewPixiCanvasSize.height * this.ScreenNumberConfiguration,
            backgroundAlpha: 0,
            // backgroundColor : 0x0A0A0A,
        });
        this.app.stage.name = "PIXIContainer";
        this.app.view.style.position = "absolute";
        this.app.stage.accessibleChildren = true;
        this.app.stage.accessible = true
        this.app.stage.sortableChildren = true;
        this.app.stop();
        //this.app.render()


        RegisterPixi(this.app, this.resid);
        this.app.view.addEventListener("webglcontextlost", this.webglcontextlostInstance);
        //this.app.start(); // use custom ticker
        this.view.appendChild(this.app.view);


        Log.Debug(this.logGroup, `InternalCreate() creating filling pot`);
        */
        this.CreateFillinPot(this.jsonSpine , this.params.clientState);

        this.OnCreatedCallback?.();
        //console.log("Spine-Created",this.resid.ID());
        //globalThis.__PIXI_APP__ = this.app;
    }

    /** use for destroy  App Pixi.js if that exist*/
    public Destroy() {

        Log.Debug(this.logGroup,  `Destroy()`);

        this.StopAnim();
        this.InternalDestroy();
        this.created = false;
        //this.restoreWebGlInterval.Stop();
    }

    public InternalDestroy() {

        Log.Debug(this.logGroup,  `InternalDestroy()`);

        if (!this.created) {
            Log.Debug(this.logGroup, `InternalDestroy(): no app, not destroying anything`);
            return;
        }


        //this.SaveCurrentIncrement();
        this.spineHit.visible = false;
        this.spineHit.renderable = false;
        Log.Debug(this.logGroup, "InternalDestroy() Destroying familyFillingPotFeature");
        this.familyFillingPotFeature?.Destroy();
        this.containerSpinnableReelsSpine?.removeFromParent();
        //this.containerSpinnableReelsSpine.destroy({children : false , texture : true , baseTexture : true});
        //SetNullReference(this.containerSpinnableReelsSpine);
        this.containerSpinnableReelsSpine = null;
        this.randomAnimationFeature.Destroy();
        this.spineHit.skeleton.setBonesToSetupPose();
        this.spineHit.skeleton.setToSetupPose();
        this.spineHit.state.update(0);
        this.spineHit.state.clearTracks();
        this.spineHit.state.clearListeners();
        //this.spineHit.removeChildren(0, this.spineHit.children.length);
        this.spineHit.removeFromParent();
        
        this.spineHit.destroy({children: true, texture: false, baseTexture: true});
        //this.familyFillingPotFeature.ClearCache(this.spineHit);
        SetNullReference(this.spineHit);
        //this.spineHit = null;


        
        this.OnDestroyCallback?.();
        //console.log('Clearing all assets from cache...');
        //console.log('Clearing all assets from cache...',PIXI.Assets.cache);
      

        // Loop through each asset in the cache
        //let v = Object.keys(PIXI.)
    
        //console.log('Clearing all assets from cache...',v);

        //PIXI.Assets.cache.remove(this.jsonResource.path);
        //console.log('Clearing all assets from cache...',PIXI.Assets.cache);
     
                
    }

    protected ShowMemory(){
        // if (window.performance && window.performance.now()) {
        //     const memory = window.performance.now();
        //     console.log(`JS Heap: ${now().usedJSHeapSize / 1024 / 1024} MB`);
        //     console.log(`Total JS Heap: ${memory.totalJSHeapSize / 1024 / 1024} MB`);
        //     console.log(`JS Heap Limit: ${memory.jsHeapLimit / 1024 / 1024} MB`);
        // } else {
        //     console.log('Performance memory API not available');
        // }
    }

    protected webglcontextlostInstance: () => void = this.webglcontextlost.bind(this);

    protected lostCount: number = 0;
    protected webglcontextlost() {
        this.lostCount++;
        Log.Error(this.logGroup, `Webgl context lost, count: ${this.lostCount}`);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
           void service.api.frontendError(FrontendErrorCode.WebGLContextLost, `${this.resid.ID()}, count: ${this.lostCount}`);

        // try recover right now, or start timer to try recover later
        let success = this.tryRecoverWebglContext();
        if (success) {
            // all good
            success = null;
            return;
        }

        // error recovering, start timer
        //this.restoreWebGlInterval.Start();
    }

    protected tryRecoverWebglContext(): boolean {

        Log.Debug(this.logGroup, "tryRecoverWebglContext()");

        if (!this.created) {
            //this.restoreWebGlInterval.Stop();
            this.recoverFailCount = 0;

            // app not created, don't care
            return true;
        }

        
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
           void service.api.frontendError(FrontendErrorCode.WebGLContextRecovering, `${this.resid.ID()}`);
        try {
            Log.Debug(this.logGroup, "tryRecoverWebglContext() trying InternalDestroy()");
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
               void service.api.frontendError(FrontendErrorCode.WebGLDestroy, `${this.resid.ID()}`);
            this.InternalDestroy();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
               void service.api.frontendError(FrontendErrorCode.WebGLDestroySuccess, `${this.resid.ID()}`);

            Log.Debug(this.logGroup, "tryRecoverWebglContext() InternalDestroy() success");
        }
        catch (ex) {
            Log.Error(this.logGroup, "tryRecoverWebglContext() exception in InternalDestroy()", ex);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
               void service.api.frontendError(FrontendErrorCode.WebGLDestroyError, `${this.resid.ID()}: ${ex.toString()}`);
        }

        try {
            Log.Debug(this.logGroup, "tryRecoverWebglContext() trying InternalCreate()");
            // Log.Debug(this.logGroup, `tryRecoverWebglContext() ${this.resid.ID()} recreating`);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
               void service.api.frontendError(FrontendErrorCode.WebGLCreate, `${this.resid.ID()}`);
            this.InternalCreate();

            // all fine, stop timer
            //this.restoreWebGlInterval.Stop();
            //console.log(this.resid.ID() + " recover success");

            this.recoverCount++;
            //this.restoreWebGlInterval.Stop();
            this.recoverFailCount = 0;

            // eslint-disable-next-line @typescript-eslint/no-floating-promises
               void service.api.frontendError(FrontendErrorCode.WebGLCreateSuccess, `${this.resid.ID()}`);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
               void service.api.frontendError(FrontendErrorCode.WebGLContextRecovered, `${this.resid.ID()}, recover count: ${this.recoverCount}`);

            Log.Debug(this.logGroup, "tryRecoverWebglContext() InternalCreate() success");
            return true;
        }
        catch (ex) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
               void service.api.frontendError(FrontendErrorCode.WebGLCreateError, `${this.resid.ID()}, ${ex.toString()}`);

            Log.Error(this.logGroup, "tryRecoverWebglContext() exception in InternalCreate()", ex);

            // prevent spamming the backend
            if (this.recoverFailCount < this.maxRecoverFailCount) {


                if (ex.message.toLowerCase().includes("this browser does not support webgl")) {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                       void service.api.frontendError(FrontendErrorCode.WebGLNotSupported, `${this.resid.ID()}, error: ${ex.toString()}`);
                }
                else {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                       void service.api.frontendError(FrontendErrorCode.WebGLRecoverError, `${this.resid.ID()}, error: ${ex.toString()}`);
                }
            }
        }

        return false;
    };

    public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
        if (loadingStage == LoadingStage.GamesConfig || loadingStage == LoadingStage.GamesPreload || loadingStage == LoadingStage.UniReel) {
            await this.PrepareResourcesGamesPreload(resourceManager);
        }

        else if (loadingStage == LoadingStage.Games) {
            await this.PrepareResourcesGames(resourceManager);
        }
    }

    protected MapFillingPotPath : Record<JackpotDisplayType , string> = {
        [JackpotDisplayType.PreciousSpin]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPot]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotOrtiz]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DragonJackpot]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotStep]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotCaliente]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotPlayCity]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.PlayCityLink]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.JubileeLink]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotJubilee]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.PaytableJackpotDisplay]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.ViventoLink]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.RapidDiamondPot]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.RapidDiamondPot2]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.RapidDiamondPotStep]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.RapidDiamondPotFire]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotRappidFrames]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotStepRappidFrames]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.RapidDiamondPotStep2]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.RainbowGirls]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotStepShared]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotStepSinShared]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotStepRappidFramesSpine]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotRappidFramesSpine]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotStepSharedSpineV2]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotStepSinSharedSpineV2]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotPyramidShared]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotPyramidSinShared]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotPyramidJP4ShareJP3SinShared]: `${this.ScreenNumberConfiguration}Screens`,
        [JackpotDisplayType.DiamondPotPyramidShared2S]: `${this.ScreenNumberConfiguration}ScreensCenter`,
        [JackpotDisplayType.DiamondPotPyramidSinShared2S]: `${this.ScreenNumberConfiguration}ScreensCenter`,
        [JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S]: `${this.ScreenNumberConfiguration}ScreensCenter`,
        [JackpotDisplayType.PlayCityLinkResponsive]:`${this.ScreenNumberConfiguration}ScreensCenter`,
        [JackpotDisplayType.PlayCityLinkResponsivePIXI]:`${this.ScreenNumberConfiguration}ScreensCenter`,
        [JackpotDisplayType.JubileeLinkResponsive]:`${this.ScreenNumberConfiguration}ScreensCenter`,
        [JackpotDisplayType.JubileeLinkResponsivePIXI]:`${this.ScreenNumberConfiguration}ScreensCenter`,
        [JackpotDisplayType.DiamondPotResponsive]:`${this.ScreenNumberConfiguration}ScreensCenter`,
        [JackpotDisplayType.DiamondPotResponsivePIXI]:`${this.ScreenNumberConfiguration}ScreensCenter`,
        [JackpotDisplayType.DiamondPotResponsivePIXIHorizontal]:`${this.ScreenNumberConfiguration}ScreensCenter`,
        [JackpotDisplayType.DiamondPotPyramidSinSharedResponsive]:`${this.ScreenNumberConfiguration}ScreensCenter`,
        [JackpotDisplayType.JubileeLinkResponsivePIXIAPPHorizontal]:`${this.ScreenNumberConfiguration}ScreensCenter`,
        [JackpotDisplayType.JackpotDisplayPlayCityPIXIAPPHorizontal]:`${this.ScreenNumberConfiguration}ScreensCenter`,
    }

    
    protected async PrepareResourcesGamesPreload(resourceManager: IWriteOnlyResourceManager): Promise<void> {
         resourceManager.AddGlobal(new JSONResource(`${this.gameResourcesBasePath}FillingPotFeature/${this.MapFillingPotPath[Settings.JackpotDisplayType]}/FillingPotPoppet${this.MapFillingPotPath[Settings.JackpotDisplayType]}.json`, ResourceIdentifier.Global.ScopedResourceName(this.gameName+"FillingPotPoppetJson")));
         resourceManager.AddGlobal(new AtlasResource(`${this.gameResourcesBasePath}FillingPotFeature/${this.MapFillingPotPath[Settings.JackpotDisplayType]}/FillingPotPoppet${this.MapFillingPotPath[Settings.JackpotDisplayType]}.atlas`, ResourceIdentifier.Global.ScopedResourceName(this.gameName+"FillingPotPoppetAtlas")));
         resourceManager.AddGlobal(new JSONResource(`${this.gameResourcesBasePath}FillingPotFeature/${this.MapFillingPotPath[Settings.JackpotDisplayType]}/FillingPotPoppet${this.MapFillingPotPath[Settings.JackpotDisplayType]}-properties.json`, ResourceIdentifier.Global.ScopedResourceName(this.gameName+"FillingPotPoppetProperties")));
    }

    public async CreateFamilyAndPrepareResources(resourceManager: IWriteOnlyResourceManager , poppetPlusPot : boolean , spinnableReels : SpinnableReelsBigCanvas ){
        let controlScale = this.jsonSpine.bones.find(bone => bone.name.startsWith("controlScale"));
        //console.log("ControlScale:", controlScale);

        let controlPointScale =  new Point(controlScale != null ? controlScale.scaleX : 1, controlScale != null ? controlScale.scaleY : 1);
        //console.log("ControlScalePoint:", controlPointScale);
        
        //this.params.jsonData = this.jsonSpine;        
        this.familyFillingPotFeature = this.familyFillingPotFeatureFactory.CreateFamily(this.familyName, this.params,controlPointScale , poppetPlusPot , spinnableReels,);
        this.familyFillingPotFeature.UpdateTargetsGlobal(this.potCollectPosition);
        await this.familyFillingPotFeature?.PrepareResources(resourceManager);
    }

    protected async PrepareResourcesGames(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        

        this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/collectHitSound` + Settings.audioFormat, this.resid.ScopedResourceName("collectHitSound")));
        this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/collectHitStartSound` + Settings.audioFormat, this.resid.ScopedResourceName("collectHitStartSound")));
        this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/collectHitBonus` + Settings.audioFormat, this.resid.ScopedResourceName("collectHitBonus")));
        this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/spineAnticipation` + Settings.audioFormat, this.resid.ScopedResourceName("spineAnticipation")));

        this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/bnstart` + Settings.audioFormat, this.resid.ScopedResourceName("BN_START"), false));
        this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/LevelAnimation_Full_LevelStart` + Settings.audioFormat, this.resid.ScopedResourceName("LevelAnimation_Full_LevelStart"), false));

        // // add sounds from random animations, this sounds are not required
        // let randomAnimations = this.jsonSpine.animations
        //     .filter(anim => anim.name.startsWith("RA_"))
        //     .map(anim => anim.name)

        // let wrongAudiosDefind = this.raAudios.filter(audio => !randomAnimations.includes(audio));
        // if (wrongAudiosDefind.length > 0) {
        //     throw new Error(`Audios not defined in spine animations: ${wrongAudiosDefind.join(", ")}`);
        // }
        
        // let animationsWithAudio = randomAnimations.filter(anim => this.raAudios.includes(anim));

        // for (let ra of animationsWithAudio) {
        //     this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/${ra}` + Settings.audioFormat, this.resid.ScopedResourceName(ra),false));
        // }

        // randomAnimations = null;


       //PrepareAudioPerLevel

       this.levelAudios.forEach(audio=>{
        this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/${audio}` + Settings.audioFormat, this.resid.ScopedResourceName(audio),false));
    })

        this.randomAnimationFeature.PrepareResources(resourceManager, this.jsonSpine);
    }

    public GetReelSize() {        
        let reelPointA = this.jsonSpine.bones.find(bone => bone.name.startsWith("reelsPointA"));
        let reelPointB = this.jsonSpine.bones.find(bone => bone.name.startsWith("reelsPointB"));
        //console.log("Reel-Point-A:", reelPointA);
        //console.log("Reel-Point-B:", reelPointB);        
        if (reelPointA == undefined || reelPointB == undefined) return this.windowRectangle;        
        return new Rect(
            Scale.X(reelPointA.x), 
            Scale.Y(reelPointA.y ) * -1 +  (Settings.Enable2plus1 == true ?  Settings.ScreenHeight : 0) ,
            Scale.W((reelPointA.x - reelPointB.x) * -1), 
            Scale.H((reelPointA.y - reelPointB.y))
        );        
    }    


    public GetPositionBonusMultiplier(){        
        let bone = this.jsonSpine.bones.find(bone => bone.name.startsWith("bonusMultiplier"));
        if(!bone) return null;
        return new Point(bone.x,bone.y);
    }

    // /** Use fore create and prepare class for spine family */
    // protected async PrepareResourcesPIXISpine(resourceManager: IWriteOnlyResourceManager)
    // {
    //     //Prepa3re Resources for PIXI

    //     //console.log("ResourcesLoadedSpine: " + `${this.gameResourcesBasePath}FillingPotFeature/FillingPotPoppet.json`, resource)

    //     let familyNameResourcesLoaed = this.jsonSpine.bones.find(bone=>bone.name.includes("Family-"));

    //     this.familyFillingPotFeature = this.familyFillingPotFeatureFactory.CreateFamily(this.view,familyNameResourcesLoaed.name,this.params);
    //     this.familyFillingPotFeature?.PrepareResources(resourceManager);
    // }

    protected jsonSpine: ISkeletonData = null;
    //protected atlasFiles: string[] = [];
   // protected atlasBasePath: string = null;

    //create Fillingletot
    protected familyName: string = null;
    protected familyFillingPotFeature: IGenericFamilySpine = null;
    protected familyFillingPotFeatureFactory: IFillinPotFamilyFactory = new FillingPotFamilyFeatureFactory();


    public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager) {
        if (loadingStage == LoadingStage.GamesConfig || loadingStage == LoadingStage.GamesPreload) {
            await this.ResourcesLoadedGamesPreload(resourceManager);
        }
        else if (loadingStage == LoadingStage.Games) {
            await this.ResourcesLoadedGames(resourceManager);
        }
    }


    //protected raAudios: string[] = [];
    protected levelAudios : string[] = [];
    protected placeHolderMutiPotConfig : PlaceHolderMutiPotConfig = null;
    protected jsonResource : JSONResource;
    protected potCollectPosition : PotCollectPosition  [] = [];
    protected async ResourcesLoadedGamesPreload(resourceManager: IReadOnlyResourceManager): Promise<void> {
        this.jsonResource = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(this.gameName+"FillingPotPoppetJson"));
        let resource = await PIXI.Assets.load(this.jsonResource.path).finally(() => {
                            PIXI.Assets.cache.remove(this.jsonResource.path);
                        });        
        this.jsonSpine = resource.spineData;

        this.familyName = this.jsonSpine.bones.find(bone => bone.name.startsWith("Family-")).name;       

        let propertiesResource = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(this.gameName+"FillingPotPoppetProperties"));
        this.placeHolderMutiPotConfig = propertiesResource.json?.["placeHolderMutiPotConfig"] ?? [];

        //this.raAudios = propertiesResource.json?.["ra_audios"] ?? [];
        this.levelAudios = propertiesResource.json?.["level_audios"] ?? [];
        //console.log(`${this.gameName}-Audio-PerLevelJsonFile:`,this.levelAudios)
        console.log(`${this.gameName}-placeHolderMutiPotConfig:`,this.placeHolderMutiPotConfig)

        this.potCollectPosition = propertiesResource.json?.["potCollectPosition"] ?? [];
        
        console.log("PositionCollect:",this.potCollectPosition);

        this.randomAnimationFeature.ResourcesLoadedGamesPreload(resourceManager)
    }


    protected async ResourcesLoadedGames(resourceManager: IReadOnlyResourceManager): Promise<void> {
        await this.familyFillingPotFeature?.ResourcesLoaded(resourceManager);
        this.familyFillingPotFeature?.AddTrack(this.audio.Track(this.resid.ScopedResourceName("collectHitSound")), "collectHitSound");
        this.familyFillingPotFeature?.AddTrack(this.audio.Track(this.resid.ScopedResourceName("collectHitStartSound")), "collectHitStartSound");
        this.familyFillingPotFeature?.AddTrack(this.audio.Track(this.resid.ScopedResourceName("collectHitBonus")), "collectHitBonus");
        this.familyFillingPotFeature?.AddTrack(this.audio.Track(this.resid.ScopedResourceName("spineAnticipation")), "spineAnticipation");
        this.familyFillingPotFeature?.AddTrack(this.audio.Track(this.resid.ScopedResourceName("BN_START")), "BN_START");
        this.familyFillingPotFeature?.AddTrack(this.audio.Track(this.resid.ScopedResourceName("LevelAnimation_Full_LevelStart")), "LevelAnimation_Full_LevelStart");
        // let randomAnimations = this.jsonSpine.animations
        //     .filter(anim => anim.name.startsWith("RA_"))
        //     .map(anim => anim.name)
        //     .filter(anim => this.raAudios.includes(anim));

        // for (let ra of randomAnimations) {
        //     this.familyFillingPotFeature?.AddTrack(this.audio.Track(this.resid.ScopedResourceName(ra)), ra);
        // }

        // randomAnimations = null;

        this.levelAudios.forEach(audio=>{
            this.familyFillingPotFeature?.AddTrack(this.audio.Track(this.resid.ScopedResourceName(audio)), audio);
        })
    }

    //protected spriteTexture: PIXI.Texture[] = [];
    protected spineHit: Spine = null;
    protected spineInitSize = new Size(Scale.W(1920), Scale.H(1080));
    //protected containerBackground: PIXI.Container = null;
    //protected containerParticlesHit: PIXI.Container = null;
    //protected familyBoneType: IBoneData = null;
    protected skinsArray :string[] = [];

    /** use for create filling pot feature */
    protected rootBone : IBone = null;
    protected CreateFillinPot(skeletonData: ISkeletonData , clientState : ClientState) {        
        //create spine Hit
        this.spineHit = new Spine (skeletonData);   
        //if(Settings.Enable2plus1 == true ) this.spineHit.position.y = Scale.Y(1080);    
        this.skinsArray = this.spineHit.spineData.skins.flatMap((value,index)=>value.name);          
        //console.log("Skins:",this.skinsArray);
        //console.log("Skin-Selected:",this.skinAttachment);
        if(this.skinsArray.length > 1) this.spineHit.skeleton.setSkinByName(this.skinsArray[this.skinAttachment]);
        //this.spineHit.renderable = false;
        //this.spineHit.autoUpdate = true;
        this.spineHit.accessibleChildren = true;
        this.spineHit.accessible = true;
        this.spineHit.sortableChildren = true;        
        //this.spineHit.zIndex = 1;
        this.app.stage.addChild(this.spineHit);        
        this.spineHit.name = `${this.gameName}-SpineHitPopet-Anim`;



        let familyBone = this.spineHit.skeleton.bones.find(b => b.data.name.includes('Family-'));
        let scaleX = Scale.X(1);
        let scaleY = Scale.Y(1);

        //let controlScale = this.spineHit.skeleton.bones.find(b => b.data.name.includes('controlScale'));        

        if (familyBone) {
            //this.spineHit.skeleton.setSlotsToSetupPose();
            this.spineHit.state.update(0);
            familyBone.data.scaleX = scaleX;
            familyBone.data.scaleY = scaleY;   
            if(Settings.Enable2plus1 == true && familyBone.data.y == 0 ) familyBone.data.y += (Settings.ScreenHeight * -1) ;         
            this.spineHit.state.apply(this.spineHit.skeleton);
            this.spineHit.state.update(0);

            this.spineHit.skeleton.setBonesToSetupPose();
            this.spineHit.skeleton.setToSetupPose();
            //rootBone = null;
            
        }

        //createContainer for Reels
        //this is for all family
        let boneRootFixPosition = this.spineHit.skeleton.findBone("reelsContainer");
        if (boneRootFixPosition != null) {
            let xPosition = boneRootFixPosition.data.x;
            let yPosition = boneRootFixPosition.data.y;
            //console.log("Position-particlesHit:", boneRootFixPosition);
            if (boneRootFixPosition.data.x < 0) xPosition = boneRootFixPosition.data.x * -1;
            if (boneRootFixPosition.data.y < 0) yPosition = boneRootFixPosition.data.y * -1;
            this.positionSpinnableReelsSpinePivotContainer = new Size(xPosition, yPosition);
            xPosition = null;
            yPosition = null;

            //create container 
            this.containerSpinnableReelsSpine = new PIXI.Container();
            this.containerSpinnableReelsSpine.name = "containerParticlesHit";
            //this.containerSpinnableReelsSpine.pivot.set(this.positionSpinnableReelsSpinePivotContainer.width, this.positionSpinnableReelsSpinePivotContainer.height);
            this.containerSpinnableReelsSpine.scale.set(1, -1);            
            //this.containerSpinnableReelsSpine.position.y = (Settings.ScreenHeight * (this.ScreenNumberConfiguration - 1)) * -1;


            //add container to particlesHit
            let containerchildrensSpine = this.spineHit.children as PIXI.Container[];
            containerchildrensSpine.forEach((container) => {
                if (container.name == "reelsContainer") {
                    container.addChild(this.containerSpinnableReelsSpine);
                    this.containerSpinnableReelsSpine.updateTransform();
                }
            });
            containerchildrensSpine = null;
            boneRootFixPosition = null;
        }
        this.familyFillingPotFeature.CreateAnimFamilyFeature(this.spineHit, this.app , this.placeHolderMutiPotConfig);
        scaleX = null;
        scaleY = null;

        this.randomAnimationFeature.StartAnimRandom(this.spineHit , clientState);
    };

    /** use for SetBet and change timeTrack per bet for Spine if you was played and hit some SRA */
    protected selecteBet: SlotGameBet = null;
    protected currentLevelPerBet: ILevelsPerBetsSaved = null;
    public SetBet(selectedBet: SlotGameBet) {

        if (!this.created) {
            return;
        }

        //console.log("SelectedBet:",selectedBet);
        this.familyFillingPotFeature?.SetBet(selectedBet);
        this.selecteBet = selectedBet;
        //console.log("SelectedBet-AllCurrentLevesSaved:",this.familyFillingPotFeature?.GetCurrentLevels());
    }

    public StartBonusWin(bonusName: string , bonusVariantName? : MultiBonusType[] , multiplier : number = 1) {
        this.familyFillingPotFeature?.StartBonusWin(bonusName  , bonusVariantName , multiplier);
    }

    public GetReelContainer(): PIXI.Container<PIXI.DisplayObject> {
        return this.containerSpinnableReelsSpine;
    };

    public StartAnticipationBegin() {
        this.familyFillingPotFeature?.StartAnticipationBegin();
    }

    public EndAnticipationBegin() {
        this.familyFillingPotFeature?.EndAnticipationBegin();
    }

    /** set new increment for change scale for part in spine */
    public StartIncrement(fillingPotIncrements: IFillingPotIncrements): void {
        this.familyFillingPotFeature?.StartIncrement(fillingPotIncrements);
    }

     /** set new increment for change scale for part in spine */
     public ReelStops(winSymbolsReelStop : string[]): void {
        this.familyFillingPotFeature?.ReelStops(winSymbolsReelStop);
    }

    public UpdateSpin() {
        this.familyFillingPotFeature?.UpdateSpin();
    }

    /** save new increment per denom its missing add per pet */
    protected SaveCurrentIncrement() {
        this.familyFillingPotFeature?.SaveCurrentIncrement();
    }

    /** pause loop anim*/
    public StopAnim(): void {

        Log.Debug(this.logGroup, `StopAnim()`);
        this.familyFillingPotFeature?.StopAnim();
    }

    /** restart loop anim */
    public RestartAnim(): void {
        Log.Debug(this.logGroup, `RestartAnim()`);
        this.familyFillingPotFeature?.RestartAnim();
    }

    public View(): HTMLElement {
        return null;
    }


    prevHaveApp: boolean = false;
    public Update(): void {
        

        if (!this.created)
        {
            return;
        }


        let haveApp = !!this.app;
        if (!haveApp)
        {
            if (this.prevHaveApp)
            {
                RobotPlay.Instance?.Disable();
                Log.Debug(this.logGroup,  `Update() No app, not updating`);
            }

            this.prevHaveApp = haveApp;
            return;
        }

        this.prevHaveApp = haveApp;

        //if (this.spineHit != null && this.app != null)
        {
            this.familyFillingPotFeature?.Update();
            //this.app?.ticker?.update();
        }
        //this.spineHit?.update(0.015);        
        //this.spineHit?.updateTransform();        
    }

    public LevelDebuggerTest(levelTestit: number = null , potIndex? : number) {
        this.familyFillingPotFeature?.LevelDebuggerTest(levelTestit , potIndex);
    }

    public PathDebuggerTest(command: string) {
        this.familyFillingPotFeature?.PathDebuggerTest(command);
    }

    protected startWinShow: boolean = false;
    public OnStartBigWinShow() {
        this.familyFillingPotFeature?.OnStartBigWinShow();
    }

    public OnEndBigWinShow() {
        this.familyFillingPotFeature?.OnEndBigWinShow();
    }

    public FillingPotDebuggerRAAnimationDebugger(numberAnimToPlay: string) {
        this.randomAnimationFeature?.FillingPotDebuggerRAAnimationDebugger(numberAnimToPlay);
        //this.familyFillingPotFeature?.FillingPotDebuggerRAAnimationDebugger(numberAnimToPlay);        
    }

    public OnCreatedCallback: OnCreatedCallbackHandler = null;
    public OnDestroyCallback: OnCreatedCallbackHandler = null;

    public IsCreated(): boolean {
        return this.created;
    }

    public GetCurrentLevels() {
        return this.familyFillingPotFeature?.GetCurrentLevels();
    }

    public SetCurrentFromBaseGameLevels(incrementSavePerBet: IIncrementSavePerBet) {
        //console.log("Particles-For-Bonus:",incrementSavePerBet);
        this.familyFillingPotFeature?.SetCurrentFromBaseGameLevels(incrementSavePerBet);
    }

    public SetSkinDebugg(skin :string){
        let regex = /[-+]?\d/g;
        let numberAnimToPlay = skin.match(regex);        
        if(this.skinsArray[numberAnimToPlay[0]] != null)
        //console.log("SkinForFind",skin);
        //console.log("Skin-Name",this.skinsArray[numberAnimToPlay[0]]);
        this.spineHit.skeleton.setSkinByName(this.skinsArray[numberAnimToPlay[0]]);
    }
    public SetSkin(skin :number){ 
        this.skinAttachment = skin;       
    }

    public ParticlesDebugger(){        
        this.familyFillingPotFeature?.ParticlesDebugger();        
    }

	public RamclearFillingPot (selectedBet: SlotGameBet){
        this.familyFillingPotFeature.RamclearFillingPot(selectedBet);
    }

    public StartPoppetRA(){
        this.randomAnimationFeature.StartRAPoppet();
    }

    public StopPoppetRA(){
        this.randomAnimationFeature.StopsRAPoppet();
    }

    public UpdateTargetsGlobal(potCollectPosition: PotCollectPosition[])
    {
        this.familyFillingPotFeature?.UpdateTargetsGlobal(potCollectPosition);
    }
}

export type OnCreatedCallbackHandler = () => void;
export type OnDestroyCallbackHandler = () => void;

